import script from "./Rule2Omastav.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rule2Omastav.vue?vue&type=script&setup=true&lang=ts"

import "./Rule2Omastav.vue?vue&type=style&index=0&id=0ca31904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca31904"]])

export default __exports__